"use client";

import Image from 'next/image';
import React from 'react';
import styles from '../styles/home2.module.css';

type Props = {
  images: string[];
};

export default function BrandsCarouselClient({ images }: Props) {
  const loopImages = [...images, ...images];

  const duration = Math.max(20, Math.floor(images.length * 0.5));

  return (
    <section className={styles['brands-section']} aria-labelledby="trusted-partners-heading">
      <div className="max-w-[1400px] py-12 md:py-16 lg:py-20 mx-auto px-4 md:px-8 lg:px-20">
        <h2 id="trusted-partners-heading" className="text-center text-2xl md:text-3xl font-semibold mb-16">Our <span className="text-emerald-600">Trusted</span> Partners</h2>
        <div className={styles['brands-container']}>
          <div
            className={styles['brands-track']}
            style={{ animationDuration: `${duration}s` }}
          >
            {loopImages.map((src, idx) => (
              <div className={styles['brand-item']} key={`${src}-${idx}`}>
                <Image src={src} alt={`brand-${idx}`} width={160} height={60} className="object-contain px-2 " />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
